import {createFeatureSelector, createSelector} from "@ngrx/store";
import {NOTIFICATIONS_FEATURE_KEY, NotificationsState} from "./notification.reducer";

export const getNotificationsState = createFeatureSelector<NotificationsState>(NOTIFICATIONS_FEATURE_KEY);
export const getNotifications = createSelector(getNotificationsState, (state) => state.notifications || []);
export const getReminder = createSelector(getNotificationsState, (state) => state.reminder);

